import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import axios from 'axios';
import {Dialog} from 'primereact/dialog';
import {ProgressBar} from 'primereact/progressbar';
import {Message} from 'primereact/message';
import {Tag} from 'primereact/tag';
import ProductionMetricsMeasuresSummary from '../productionmetricsmeasuressummary/ProductionMetricsMeasuresSummary';

const idOf = value => value && typeof value === 'object' ? value.id : value;
const itemIdOf = value => idOf(value?.project_item) || value?.project_item_id || value?.projectItem?.id || value?.projectItemId || null;

export default function ProductionJobDetailsDialog({jobId, onHide}) {
  const {t} = useTranslation('common');
  const [job, setJob] = useState(null);
  const [itemId, setItemId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const network = localStorage.getItem('networkId');
  useEffect(() => {
    let cancelled = false;
    const controller = new AbortController();
    setJob(null); setItemId(null); setError('');
    if (!jobId) return () => controller.abort();
    setLoading(true);
    const get = path => axios.get(`${process.env.REACT_APP_API_HOST}/api/v2/${path}`, {signal: controller.signal,
      headers: {Authorization: `Bearer ${localStorage.getItem('userToken')}`, 'App-Network': network}});
    (async () => {
      try {
        const data = (await get(`production-job/${jobId}`))?.data?.data;
        if (!data?.id) throw new Error('Missing production job');
        let item = itemIdOf(data) || itemIdOf(data.production_item);
        const operation = idOf(data.production_item) || data.production_item_id;
        if (!item && operation) item = itemIdOf((await get(`production-item/${operation}`))?.data?.data);
        if (!cancelled) { setJob(data); setItemId(item); }
      } catch (e) { if (!cancelled) setError(e?.response?.data?.detail || e?.response?.data?.message || 'error'); }
      finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; controller.abort(); };
  }, [jobId, network]);
  const status = typeof job?.status === 'object' ? job.status?.value : job?.status;
  return <Dialog header={t('taskDetails')} visible={!!jobId} modal style={{width: '60rem', maxWidth: '95vw'}} onHide={onHide}>
    {loading && <ProgressBar mode="indeterminate" style={{height: '5px'}}/>}
    {error && <Message severity="error" text={t(error, {defaultValue: error})}/>}
    {!loading && job && <>
      <div className="p-p-3 p-mb-3" style={{border: '1px solid var(--surface-d)', borderRadius: 6}}>
        <p><strong>{t('name')}:</strong> {job.production_item?.name || '—'}</p>
        <p><strong>{t('shiftProjectNumber')}:</strong> {job.project_number || '—'}</p>
        <p><strong>{t('status')}:</strong> <Tag value={t(`productionStatus.${status}`, {defaultValue: status || '—'})}/></p>
        <p><strong>{t('quantity')}:</strong> {job.quantity ?? 0} {job.unit?.name || ''}</p>
        <p><strong>{t('externalReference')}:</strong> {job.production_item?.external_reference || '—'}</p>
      </div>
      <ProductionMetricsMeasuresSummary productionJobId={job.id} t={t} title={t('productionDataRecordedForTask')} emptyMessage={t('noProductionDataRecordedForTask')} showProjectItemDetails={false}/>
      {itemId && <ProductionMetricsMeasuresSummary projectItemId={itemId} t={t}/>}
    </>}
  </Dialog>;
}
